export default "__VITE_ASSET__CiqWLIyT__"